import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import LogoImg from '../images/logo.svg';


export default class Header extends React.Component {

  state = {
    sidemenu: 'closed',
  };

  toggleSideMenu() {
    if (this.state.sidemenu === 'closed') {
      this.setState({ sidemenu: 'open' });
      document.getElementsByTagName('html')[0].classList.add('menu-open');
    } else {
      this.setState({ sidemenu: 'closed' });
      document.getElementsByTagName('html')[0].classList.remove('menu-open');
    }
  }

  closeSideMenu() {
    if (this.state.sidemenu === 'open') {
      this.setState({ sidemenu: 'closed' });
      document.getElementsByTagName('html')[0].classList.remove('menu-open');
    }
  }

  render() {
    return (
      <header className="header-container">
        <Link to='/' className="logo" onClick={this.closeSideMenu.bind(this)}>
          <span>
            <img src={LogoImg} alt="Sanoma Games" />
          </span>
        </Link>
        <nav className="header-nav">
          <ul>
            <li>
              <NavLink
                to="/"
                onClick={this.closeSideMenu.bind(this)}
                title="Ratkaisut"
                className={({ isActive }) => isActive ? "active" : ""}
              >
                Ratkaisut
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/me"
                onClick={this.closeSideMenu.bind(this)}
                title="Me"
                className={({ isActive }) => isActive ? "active" : ""}
              >
                Me
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/ota-yhteytta"
                onClick={this.closeSideMenu.bind(this)}
                title="Ota yhteyttä"
                className={({ isActive }) => isActive ? "active" : ""}
              >
                Ota yhteyttä
              </NavLink>
            </li>
          </ul>
        </nav>
        <button className="nav-toggle" aria-label="menu" onClick={this.toggleSideMenu.bind(this)}></button>
      </header>
    );
  }
}
